export async function loadDashboardCharts(api, baseURL, startDate, endDate) {
  const limit = 500;
  const all = [];
  // Окна, когда молчали все агенты (agent_silence от API). Между страницами — пересечение. Нет поля — неизвестно.
  let silence;
  const intersect = (a, b) => a.flatMap((x) => b.map((y) => ({ from: Math.max(x.from, y.from), to: Math.min(x.to, y.to) }))).filter((g) => g.to > g.from);
  for (let offset = 0; ; offset += limit) {
    const response = await api.get(`${baseURL}/device-api/v1/dashboard/charts`, {params: {
      start_date: startDate.toISOString(), end_date: endDate.toISOString(),
      device_limit: limit, device_offset: offset,
    }});
    const charts = response.data?.charts;
    if (!Array.isArray(charts)) throw new Error('Invalid chart response');
    all.push(...charts);
    const page = Array.isArray(response.data.agent_silence)
      ? response.data.agent_silence.map((g) => ({ from: Date.parse(g.from), to: Date.parse(g.to) })) : null;
    silence = offset === 0 ? page : (silence && page ? intersect(silence, page) : null);
    if (response.data.pagination?.has_more_devices === false || charts.length < limit) {
      all.agentSilence = silence || undefined;
      return all;
    }
  }
}
